import { apiClient } from '@/lib/api';

/**
 * Reglas de la demo (spec 343): en qué estado está la empresa de la sesión. Lo calcula la
 * función única del servidor (`estadoDeLaDemo`). 🔴 La pantalla no deduce nada: lo que se
 * lee de acá se lee en `textos-del-estado-de-la-demo.ts` y en ningún otro lado (lo vigila
 * `estado-de-la-demo.guard.test.ts`).
 */
export interface TiendaDeLaPrueba {
  sitio: string;
  nombre: string;
}

export interface EstadoDeLaEmpresaEnPrueba {
  esDemo: true;
  archivada: boolean;
  eje: {
    estado: 'ELEGIDO' | 'SIN_TIENDAS_LEIDAS';
    id: string | null;
    nombre: string | null;
  };
  tienda: {
    estado: 'NINGUNA' | 'ELEGIDA';
    /** Las encendidas de verdad: 0 sin tienda elegida. */
    usadas: number;
    tope: number;
    actual: TiendaDeLaPrueba | null;
    archivadas: Array<TiendaDeLaPrueba & { archivadaEl: string }>;
  };
  productos: { estado: 'BAJO' | 'EN_EL_TOPE'; usados: number; tope: number | null };
  actividad: {
    estado: 'ACTIVA' | 'ABANDONADA';
    ultimoIngresoEl: string | null;
    diasSinIngreso: number;
  };
  venta: { estado: 'EN_PRUEBA' | 'LISTA_PARA_LA_VENTA' };
  /**
   * Fase 2 (carril Alta): la entrega del catálogo de la tienda actual terminó (cola
   * `demo-entrega`). Un servidor anterior no lo manda: sin el campo no falta nada.
   */
  catalogoListo?: boolean;
  /**
   * Decisión 3 del 3-nov: el socio de la invitación por la que entró (p. ej. «EGX One»); `null` sin
   * socio. Un servidor anterior no lo manda.
   */
  socio?: string | null;
}

export type EstadoDeLaDemo = { esDemo: false } | EstadoDeLaEmpresaEnPrueba;

export const demoService = {
  estado: (): Promise<EstadoDeLaDemo> => apiClient.get('/api/demo/estado'),
};

/**
 * Decisión 1 del 3-nov: la tienda de la prueba se elige adentro (Compite › Competencia). Quien la
 * elige o la cambia avisa con este evento, y quien muestra el estado (las misiones) lo vuelve a pedir.
 */
export const EVENTO_TIENDA_DE_LA_PRUEBA = 'mini-prixia:tienda-de-la-prueba';

export const avisarCambioDeTiendaDeLaPrueba = (): void => {
  window.dispatchEvent(new Event(EVENTO_TIENDA_DE_LA_PRUEBA));
};
